import React from "react"

interface Props {
  className?: string
}

const KhumoIcon = ({ className }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19 20V4C19 2.89543 18.1046 2 17 2H10.346C9.98188 2 9.62472 2.09938 9.31297 2.28742L9.16072 2.37925C8.84897 2.56729 8.4918 2.66667 8.12773 2.66667H7C5.89543 2.66667 5 3.5621 5 4.66667V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.5 6H8.5C8.22386 6 8 6.22386 8 6.5V18.5C8 18.7761 8.22386 19 8.5 19H15.5C15.7761 19 16 18.7761 16 18.5V6.5C16 6.22386 15.7761 6 15.5 6Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default KhumoIcon
